import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';

import TrainingExtraCard from 'components/TrainingGrid/TrainingExtraCard';

/**
 * Centralized card for a single itinerary module. Used both in the grid (inline when
 * openable_section is false) and in the itinerary sub-view (when openable_section is true).
 */
const ItineraryModuleCard = ({
  appId,
  module,
  redirPath = '',
  linkPathSegment = 'itineraries',
  locked = false,
  foundationLocked = false,
  className = '',
  lockedSubtitle = false,
  lockedSubtitleOverride = null,
}) => (
  <div className={clsx('trainingCard__Animated', className)}>
    <TrainingExtraCard
      appId={appId}
      module={module}
      redirPath={redirPath}
      linkPathSegment={linkPathSegment}
      locked={locked}
      foundationLocked={foundationLocked}
      lockedSubtitle={lockedSubtitle}
      lockedSubtitleOverride={lockedSubtitleOverride}
    />
  </div>
);

ItineraryModuleCard.propTypes = {
  appId: PropTypes.number.isRequired,
  module: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    image: PropTypes.string,
    percentage: PropTypes.number,
    category_percentage: PropTypes.number,
    sub_app: PropTypes.object,
  }).isRequired,
  redirPath: PropTypes.string,
  linkPathSegment: PropTypes.string,
  locked: PropTypes.bool,
  foundationLocked: PropTypes.bool,
  className: PropTypes.string,
  lockedSubtitle: PropTypes.bool,
  lockedSubtitleOverride: PropTypes.string,
};

export default ItineraryModuleCard;
